import { render, staticRenderFns } from "./OverlayMiniTable.vue?vue&type=template&id=3f1b23fa&scoped=true&"
import script from "./OverlayMiniTable.vue?vue&type=script&lang=js&"
export * from "./OverlayMiniTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b23fa",
  null
  
)

export default component.exports